(function ($, Drupal) {
  Drupal.behaviors.AndechserSelect2 = {
    attach: function (context, settings) {

      function iconFromValue(val){
        if(val.element && val.element.value !== 'All'){
          const iconUrl = val.element.dataset['icon'] || `/themes/an/assets/images/category/${val.element.value}.svg`;
          val = `<span class="select2-option-img"><span><img class="select2-option-img__image" src="${iconUrl}"></span> ${val.text}`;
        } else {
          val = val.text;
        }
        return val;
      }

      $(once('product-finder', '.product-finder .form-item-kat .form-select', context)).select2({
        dropdownCssClass : 'no-search',
        placeholder: Drupal.t('Choose'),
        templateResult: iconFromValue,
        templateSelection: iconFromValue,
        escapeMarkup: function(m) { return m; }
      });

      $(once('product-finder-not', '.product-finder .form-item:not(.form-item-kat) .form-select', context)).select2({
        dropdownCssClass : 'no-search',
        placeholder: Drupal.t('Choose')
      });

      $(once('ajax-complete', document )).ajaxComplete(function( event, xhr, settings ) {
        $(once('product-finder-not-2', '.product-finder .form-item:not(.form-item-kat) .form-select', context)).select2({
          dropdownCssClass : 'no-search',
          placeholder: Drupal.t('Choose')
        });

        $(once('product-finder-3', '.product-finder .form-item-kat .form-select', context)).select2({
          dropdownCssClass : 'no-search',
          placeholder: Drupal.t('Choose'),
          templateResult: iconFromValue,
          templateSelection: iconFromValue,
          escapeMarkup: function(m) { return m; }
        });
      });

      if ($(window).width() < 992) {
        $(once('kat2', '.form-item-kat2', context)).nextUntil($('.form-item-kat2', context).siblings(':last')).wrapAll('<div id="filter-wrapper" class="collapse row m-0 w-100"></div>');
        var kat2 = $('.form-item-kat2', context);
        kat2.not('.processed').after('<div class="h6 text-center more-filter-link--wrapper mt-3"><a class="more-filter-link collapsed " data-bs-toggle="collapse" href="#filter-wrapper">Weiter Filter anzeigen</a></div>');
        kat2.addClass('processed');
      }

    }
  };
})(jQuery, Drupal);
